__turbopack_context__.v({
  "body_rich_text": "VideoModule-module-scss-module__B4NNHG__body_rich_text",
  "direction__column": "VideoModule-module-scss-module__B4NNHG__direction__column",
  "direction__row": "VideoModule-module-scss-module__B4NNHG__direction__row",
  "gradient-glow-blue": "VideoModule-module-scss-module__B4NNHG__gradient-glow-blue",
  "gradient-glow-neon": "VideoModule-module-scss-module__B4NNHG__gradient-glow-neon",
  "gradient-glow-orange": "VideoModule-module-scss-module__B4NNHG__gradient-glow-orange",
  "gradient-glow-pink": "VideoModule-module-scss-module__B4NNHG__gradient-glow-pink",
  "gradient-glow-snap-pea": "VideoModule-module-scss-module__B4NNHG__gradient-glow-snap-pea",
  "gradient-neon-pink": "VideoModule-module-scss-module__B4NNHG__gradient-neon-pink",
  "gradient-pink-blue": "VideoModule-module-scss-module__B4NNHG__gradient-pink-blue",
  "gradient-pink-orange": "VideoModule-module-scss-module__B4NNHG__gradient-pink-orange",
  "layout__content-leading": "VideoModule-module-scss-module__B4NNHG__layout__content-leading",
  "layout__content-trailing": "VideoModule-module-scss-module__B4NNHG__layout__content-trailing",
  "module-base": "VideoModule-module-scss-module__B4NNHG__module-base",
  "module-content-swap": "VideoModule-module-scss-module__B4NNHG__module-content-swap",
  "module-video": "VideoModule-module-scss-module__B4NNHG__module-video",
  "module_block__contained": "VideoModule-module-scss-module__B4NNHG__module_block__contained",
  "module_block__uncontained": "VideoModule-module-scss-module__B4NNHG__module_block__uncontained",
  "module_breadcrumbs": "VideoModule-module-scss-module__B4NNHG__module_breadcrumbs",
  "section_bg_fill__base": "VideoModule-module-scss-module__B4NNHG__section_bg_fill__base",
  "section_bg_fill__gradient": "VideoModule-module-scss-module__B4NNHG__section_bg_fill__gradient",
  "section_bg_fill__no-fill": "VideoModule-module-scss-module__B4NNHG__section_bg_fill__no-fill",
  "section_bg_fill__raised": "VideoModule-module-scss-module__B4NNHG__section_bg_fill__raised",
  "section_container": "VideoModule-module-scss-module__B4NNHG__section_container",
  "with_breadcrumb": "VideoModule-module-scss-module__B4NNHG__with_breadcrumb",
  "with_navbar": "VideoModule-module-scss-module__B4NNHG__with_navbar",
});
